const companyRequiredFields: NodeListOf<HTMLInputElement> = document.querySelectorAll('.required-company');
const vatRequiredFields: NodeListOf<HTMLInputElement> = document.querySelectorAll('.required-vat');
let validateBusiness: boolean = false;
let validateVat: boolean = false;

$(() => {
    $('#ProbeAboLandingpageForm').on('submit', function() {
        let isValid = true;
        companyRequiredFields.forEach(field => {
            field.setCustomValidity('');
            if (validateBusiness && field.value == '') {
                field.setCustomValidity('Füllen Sie dieses Feld aus.');
                field.checkValidity();
                field.reportValidity();
                isValid = false;
            }
        });

        vatRequiredFields.forEach(field => {
            field.setCustomValidity('');
            if (validateVat && field.value == '') {
                field.setCustomValidity('Füllen Sie dieses Feld aus.');
                field.checkValidity();
                field.reportValidity();
                isValid = false;
            }
        });

        if (!isValid) {
            return false;
        }

        const spinnerModal = $('#spinnerModal');
        spinnerModal.removeClass('hide');

        $(this)
            .find('button[type=submit]')
            .hide();
    });

    $('#ProbeAboLandingpageForm input[type=text]').on('input', function() {
        if ($(this).val() !== '') {
            $(this).addClass('input-green-check');
        } else {
            $(this).removeClass('input-green-check');
        }
    });

    function onFormChange() {
        var usageValue = ($('.usage-select')[0] as HTMLSelectElement).value;
        var showVat = $('.CountryListGeschaeftlich')
            .find('option:selected')
            .data('showvat');

        if (usageValue === 'business') {
            $('#company-fields').removeClass('hide');
            $('#Company').trigger('focus');
            validateBusiness = true;
        } else {
            $('#company-fields').addClass('hide');
            validateBusiness = false;
        }

        if (usageValue === 'business' && showVat === 'True') {
            $('#VATEntry').removeClass('hide');
            validateVat = true;
        } else {
            $('#VATEntry').addClass('hide');
            validateVat = false;
        }
    }

    //Blendet wenn ein Land mit dem Eintrag "ShowVAT" ausgewählt wird das VAT-Feld ein
    $('.CountryListGeschaeftlich').on('change', function() {
        onFormChange();
    });

    //Blendet das Company-Feld ein wenn die Nutzung auf "Geschaeftlich" steht
    $('.usage-select').on('change', function() {
        onFormChange();
    });

    if ($('#Company').val() || $('#preSelect').val() === 'Geschäftlich') {
        $('.usage-select').val('business');
        onFormChange();
    } else if ($('#preSelect').val() === 'Privat') {
        $('.usage-select').val('private');
        onFormChange();
    }
});
